import LCI from "../images/image.png";
import NPS from "../images/image1.png";
import CO2 from "../images/image2.png";
import TST from "../images/image3.png";
import ST from "../images/image4.png";
import guvi from "../images/guvi.jpeg";
import iamneo from "../images/iamneo.jpg";
import care from "../images/care.jpg";
import mct from "../images/mct.jpg";
import nptel from "../images/nptel.jpg";
import cisco from "../images/cisco.jpg";
import servicenow from "../images/sn.jpg";
import django from "../images/django.png";
import pbi from "../images/pbi.jpg";
import mongodb from "../images/mdb.jpg";
import skcet from "../images/skcet.jpeg";

export const Bio = {
  name: "Mahalaxmi Kannan",
  roles: [
    "Aspiring AI/ML Engineer",
    "Full Stack Developer",
    "Programmer",
    "Problem Solver",
  ],
  description:
    "Second-year Artificial Intelligence & Data Science student skilled in Python, Java, MERN Stack, AI/ML, and Data Analysis. Passionate about building smart solutions through code and data.",
  github: "https://github.com/MahalaxmiKannan",
  resume: `${process.env.PUBLIC_URL}/resume.pdf`,
  linkedin: "https://www.linkedin.com/in/mahalaxmi-k-584684319/",
  twitter: "",
  insta: "",
  facebook: ""
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg",
      },
      {
        name: "HTML",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg",
      },
      {
        name: "CSS",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg",
      },
      {
        name: "Figma Basics",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Java",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg",
      },
      {
        name: "Spring boot",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      {
        name: "Django",
        image:
          "https://static.djangoproject.com/img/logos/django-logo-negative.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tensorflow",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "Keras",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/a/ae/Keras_logo.svg",
      },
      {
        name: "Pandas",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg",
      },
      {
        name: "Scikit-learn",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/scikitlearn/scikitlearn-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Power BI",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/c/cf/New_Power_BI_Logo.svg",
      },
      {
        name: "Snowflake",
        image:
          "https://www.vectorlogo.zone/logos/snowflake/snowflake-icon.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "https://yt3.googleusercontent.com/l7Pfr47b8sGLoa0m13On6sHt9STatMi3kuO0k67HxxmkqkvoDHerkU_vqmO0cs9jvFjPEqG3Fg=s900-c-k-c0x00ffffff-no-rj",
    role: "Artificial Intelligence  Intern",
    company: "CodTech IT Company",
    date: "Feb 2025 - Mar 2025",
    desc: "• Engineered a deep learning speech recognition model in Python + TensorFlow achieving 90%+ transcription accuracy\n• Built a Transformer-based NLP text summarizer reducing content length by 60% while retaining semantic context\n• Delivered 2 production-ready AI models within a 2-month remote internship timeline",
    skills: [
      "Python",
      "TensorFlow",
      "NLP",
      "Transformers",
      "Deep Learning",
    ],
    doc: "https://yt3.googleusercontent.com/l7Pfr47b8sGLoa0m13On6sHt9STatMi3kuO0k67HxxmkqkvoDHerkU_vqmO0cs9jvFjPEqG3Fg=s900-c-k-c0x00ffffff-no-rj",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGxSpvp6sSs3TwL8ZJNXrpIkZq9cItGsB4Cg&s",
    role: "Machine Learning Intern",
    company: "Alfido Tech Pvt. Ltd.",
    date: "May 2025 - June 2025",
    desc: "• Built supervised ML models (Logistic Regression, SVM, Random Forest) for Iris classification and house price prediction on 10,000+ record datasets — 95% accuracy\n• Achieved 15% efficiency gain through feature engineering and hyperparameter tuning\n• Presented model results and insights to technical team leads",
    skills: [
      "Python",
      "Scikit-learn",
      "Pandas",
      "Machine Learning",
      "Data Analysis",
    ],
    doc: "https://www.alfidotech.com/logo.png",
  },
  {
    id: 2,
    img: "https://play-lh.googleusercontent.com/snigMTGEN_kGsK71jRtGkAMbjFSwWg7lfMa5QP9kzWR69ZuodJOdePQP0E1crUi8e6ryIj66fQ8TxMSZrL9X0NQ",
    role: "AI Development Trainee",
    company: "Mirai School of Technology",
    date: "Jan 2026 - Feb 2026",
    desc: "• Built and deployed end-to-end AI applications through a 6-week intensive programme\n• Worked with LLM-based development tools, prompt engineering, and agentic AI workflows\n• Hands-on experience with Streamlit, Cursor AI, and modern AI product development practices",
    skills: [
      "Python",
      "LLMs",
      "Prompt Engineering",
      "Streamlit",
      "Cursor AI",
    ],
    doc: "https://mirai.school/logo.png",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSKr1pTbaKKe2ZrppTP0NgQywn4tvP9LVTkiw&s",
    school: "The Ashok Leyland School, Hosur, Tamil Nadu",
    date: "June 2010 - May 2024",
    grade: "98 % in 10th, 95% in 12th",
    desc: "Completed grades 1-12 at The Ashok Leyland School, Hosur. Graduated as top student in class — 98% in 10th, 95% in 12th.",
    degree: "CBSE(XII), Science with Computer",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSDyDdFVTjUsQDS0s55Q4HGmNlsf7EkLFOyWg&s",
    school: "Sri Krishna College Of Engineering And Technology, Coimbatore, Tamil Nadu",
    date: "Aug 2024 - May 2028",
    grade: "8.63 CGPA",
    desc: "I am pursuing my B.Tech degree in this institution. I have successfully completed my 2nd year of engineering. Looking forward.",
    keyCourses: "Machine Learning, Data Analytics, Data Structures, DBMS, Computer Networks",
    achievement: "Top performer among 120+ peers in AI & Data Science department",
    degree: "Bachelor of Technology - BTech, Artificial Intelligence And Data Science",
  },
];

export const projects = [
  {
    id: 0,
    title: "Leetcode Tutor - Browser Extension",
    date: "Oct 2025",
    description:
      "An intelligent browser extension that provides contextual hints, explanations, and guidance while solving LeetCode problems.",
    image: LCI,
    tags: ["JavaScript", "Chrome Extension API", "Browser Extension"],
    category: "DATA",
    github: "https://github.com/MahalaxmiKannan/LEETCODE-TUTOR",
    webapp: "https://github.com/MahalaxmiKannan/LEETCODE-TUTOR",
  },
  {
    id: 1,
    title: "Resort Room Booking System",
    date: "Jan 2026",
    description:
      "A full-stack web application that enables users to manage resort rooms using a React frontend and Spring Boot backend.",
    image:
      "https://roomraccoon.com/wp-content/uploads/2023/07/HMS-Blog-hero.jpg",
    tags: ["React", "Spring Boot", "Java", "MySQL", "REST API"],
    category: "WEB APPS",
    github: "https://github.com/MahalaxmiKannan/RESORT-ROOM-BOOKING-SYSTEM",
    webapp: "https://github.com/MahalaxmiKannan/RESORT-ROOM-BOOKING-SYSTEM",
  },
  {
    id: 2,
    title: "NexusPay - Salary Prediction",
    date: "Jul 2025",
    description:
      "A machine learning system that predicts salary ranges based on skills, experience, and role using predictive analytics.",
    image: NPS,
    tags: ["Python", "Scikit-learn", "Random Forest", "Pandas", "Streamlit"],
    category: "AI/ML",
    github: "https://github.com/MahalaxmiKannan/NEXUSPAY_SALARY_PREDICTION",
    webapp: "https://github.com/MahalaxmiKannan/NEXUSPAY_SALARY_PREDICTION",
  },
  {
    id: 3,
    title: "Carbon Emission Tracker",
    date: "DATA",
    description:
      "A data-driven platform that analyzes activities and estimates carbon emissions to promote sustainable decision-making.",
    image: CO2,
    tags: ["React", "Django", "MongoDB", "Data Analytics"],
    category: "DATA",
    github: "https://github.com/MahalaxmiKannan/SAKTHI_CARBON-TRACKER",
    webapp: "https://github.com/MahalaxmiKannan/SAKTHI_CARBON-TRACKER",
  },
  {
    id: 4,
    title: "Text Summarization Tool",
    date: "Feb 2025",
    description:
      "An NLP-based application that automatically generates concise summaries from long-form text using AI models.",
    image: TST,
    tags: ["Python", "HuggingFace Transformers", "NLP", "Streamlit"],
    category: "AI/ML",
    github: "https://github.com/MahalaxmiKannan/TEXT-SUMMARIZATION-TOOL",
    webapp: "https://github.com/MahalaxmiKannan/TEXT-SUMMARIZATION-TOOL ",
  },
  {
    id: 5,
    title: "Stranger Things – Fan Hub",
    date: "Jan 2026",
    description:
      "A responsive fan-centric web platform showcasing episodes, characters, and interactive content for the Stranger Things series.",
    image: ST,
    tags: ["Html", "Css", "Javascript"],
    category: "WEB APPS",
    github: "https://github.com/MahalaxmiKannan/STRANGER-THINGS---FAN-HUB",
    webapp: "https://github.com/MahalaxmiKannan/STRANGER-THINGS---FAN-HUB",
  },
];

export const certifications = [
  {
    id: 0,
    title: "Joy of Computing with Python",
    date: "March 2024",
    issuer: "IIT - Madras (NPTEL)",
    image: nptel,
    file: "/certificates/nptel.pdf",
  },
  {
    id: 1,
    title: "Networking Basics",
    date: "December 2024",
    issuer: "Cisco",
    image: cisco,
    file: "/certificates/cisco.pdf",
  },
  {
    id: 2,
    title: "Micro-Certification",
    date: "December 2024",
    issuer: "Service now",
    image: servicenow,
    file: "/certificates/sn.pdf",
  },
  {
    id: 3,
    title: "Django",
    date: "July 2025",
    issuer: "Meta (Coursera)",
    image: django,
    file: "/certificates/django.pdf",
  },
  {
    id: 4,
    title: "Power BI - Data Analyst",
    date: "March 2025",
    issuer: "Microsoft (Coursera)",
    image: pbi,
    file: "/certificates/pbi.pdf",
  },
  {
    id: 5,
    title: "MongoDB",
    date: "January 2025",  
    issuer: "Infosys Springboard",
    image: mongodb,
    file: "/certificates/mdb.pdf",
  },
  // Add more as needed
];

export const achievements = [
  {
    id: 0,
    title: "Guvi SheCodes Hackathon - 2025",
    result: "4th Place Winner",
    date: "March 2025",
    desc: "Designed and prototyped “ElevateHer”, a career empowerment platform for women, focusing on UI/UX-friendly workflows and accessibility.",
    image: guvi, // Replace with your team photo
  },
  {
    id: 1,
    title: "Iamneo HackSprint 2 - 2026",
    result: "Finalist",
    date: "Jan 2026",
    desc: "Built a Job Recommender and Career Analytics Platform that analyzes user skills and career data to generate personalized job recommendations and actionable career insights.",
    image: iamneo, // A vertical photo looks great in an album
  },
  {
    id: 2,
    title: "Care Hackathon - 2025",
    result: "Top 10 Finalist",
    date: "Sept 2023",
    desc: "Proposed an innovative AI-powered Skin Medical Patch by exploring its functional layers for real-time health monitoring and medicine dispensing.",
    image: care, // Replace with your team photo
  },
  {
    id: 3,
    title: "Masala Coding - Thiran 2026",
    result: "Winner",
    date: "Feb 2026",
    desc: "First prize at Masala Coding (Thiran), Sri Eshwar College of Engineering; outpaced competitors in high-pressure MCQ and algorithmic rounds to secure a ₹3000 cash award.",
    image: mct, // Replace with your team photo
  },
  {
    id: 4,
    title: "Top Academic Performer — SKCET",
    result: "CGPA : 8.63",
    date: "2024 - present",
    desc: "Maintaining top academic performance among 120+ peers in AI & Data Science department. CGPA: 8.63.",
    image: skcet,
  }
];